export default {"src":"/_next/static/media/ferpectionlogo.0090d7f5.svg","height":182,"width":998,"blurWidth":0,"blurHeight":0};